import {SECONDS_IN_MINUTE, SECONDS_IN_HOUR} from '../../../constants/constants';
import {EditableFieldProps} from './types';

export const formattedTime =
(time: number, withHours = false) => {
  const hours = withHours ? `${Math.floor(time / (SECONDS_IN_HOUR))}` : '';
  let minutes = withHours ?
  `${Math.floor((time - (Number(hours) * (SECONDS_IN_HOUR))) / SECONDS_IN_MINUTE)}` :
  `${Math.floor(time / SECONDS_IN_MINUTE)}`;
  const seconds = ('0' + Math.floor(time % SECONDS_IN_MINUTE)).slice(-2);

  if (+minutes < 10 && withHours) {
    minutes = '0'+minutes;
  }

  return {
    hours,
    minutes,
    seconds
  };
};

export const convertTimeInSeconds = (time: EditableFieldProps) => (
  time.hours ?
  (+time.hours) * SECONDS_IN_HOUR +
  (+time.minutes) * SECONDS_IN_MINUTE + (+time.seconds) :
  (+time.minutes) * SECONDS_IN_MINUTE + (+time.seconds)
);
